// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__zv+-C","icon":"SearchInput_icon__45jpt"};